import React, { useEffect, useState } from 'react';

import { NoImprovementScreen } from '@atlassian/generative-ai-modal/screens/NoImprovement';

import { type StreamFns } from '../../../../pm-plugins/in-editor-direct-streaming/hooks/useInEditorDirectStreaming';
import { useAIExperienceCommonDataContext } from '../../../hooks/useAIExperienceCommonData';

/**
 * No Improvement Screen with Logic
 * This screen is shown when the AI model does not provide any improvement
 * to the user's input.
 */
export function NoImprovementScreenWithLogic({
	discardStream,
}: {
	discardStream: StreamFns['discardStream'];
}) {
	const aiExperienceCommonData = useAIExperienceCommonDataContext();
	const { endExperience, editorView } = aiExperienceCommonData;

	const [isHidden, setIsHidden] = useState(false);

	useEffect(() => {
		discardStream?.({ restoreSelection: false });

		const timer = setTimeout(() => {
			setIsHidden(true);
		}, 1000);

		return () => clearTimeout(timer);
	}, [editorView, discardStream]);

	// TODO: EDITOR-1085 - Add analytics for no improvement screen
	return <NoImprovementScreen isHidden={isHidden} onceFade={endExperience} />;
}
